import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUX_SLICE_KEYS, Tabs, PaymentType } from 'common/constants';
import type { RootState } from 'store';

interface PageHeaderState {
  readonly selectedPaymentType?: string;
  readonly selectedTab: string;
}

const initialState: PageHeaderState = {
  selectedPaymentType: PaymentType.AccountsPayable,
  selectedTab: ''
};

export const headerSlice = createSlice({
  name: REDUX_SLICE_KEYS.header,
  initialState,
  reducers: {
    setSelectedPaymentType: (state, action: PayloadAction<string>) => {
      state.selectedPaymentType = action.payload;
    },
    setSelectedTab: (state, action: PayloadAction<string>) => {
      state.selectedTab = action.payload;
    }
  }
});

export const { setSelectedPaymentType, setSelectedTab } = headerSlice.actions;

const selectSelf = (state: RootState) => state;

export const getSelectedPaymentType = createSelector(
  selectSelf,
  ({ header }) => header.selectedPaymentType
);

export const getSelectedTab = createSelector(
  selectSelf,
  ({ header }) => header.selectedTab
);

export const getSelectedTabToBePaid = createSelector(
  getSelectedTab,
  getTab => getTab === Tabs.ToBePaid
);

export default headerSlice.reducer;
